import React, { useRef, useState, useEffect } from 'react';
import { Canvas, useFrame, useThree } from '@react-three/fiber';

function CategoryCube({ category, index, totalCategories, isHighlighted, onClick }) {
  const mesh = useRef();
  const [mounted, setMounted] = useState(false);
  const [spun, setSpun] = useState(false);
  const [progress, setProgress] = useState(0);
  const [clicked, setClicked] = useState(false);
  
  // All cubes very close to center with slight 3D spread
  const cubeSize = 0.8; // Size of each cube
  
  // Calculate position based on number of cubes
  let x, y, z;
  
  if (totalCategories === 2) {
    // Special case for 2 cubes - place them side by side without overlapping
    const spacing = cubeSize * 1; // Distance between centers (no overlap)
    x = index === 0 ? -spacing / 2 : spacing / 2;
    y = 0;
    z = 0;
  } else if (totalCategories === 3) {
    // Special case for 3 cubes - two side by side, third on top
    const spacing = cubeSize * 1; // Distance between centers
    if (index === 0) {
      // First cube - left side
      x = -spacing / 2;
      y = 0;
      z = 0;
    } else if (index === 1) {
      // Second cube - right side
      x = spacing / 2;
      y = 0;
      z = 0;
    } else {
      // Third cube - on top
      x = 0;
      y = spacing;
      z = 0;
    }
  } else if (totalCategories === 4) {
    // Special case for 4 cubes - square formation
    const spacing = cubeSize * 1; // Distance between centers
    if (index === 0) {
      // First cube - top left
      x = -spacing / 2;
      y = spacing / 2;
      z = 0;
    } else if (index === 1) {
      // Second cube - top right
      x = spacing / 2;
      y = spacing / 2;
      z = 0;
    } else if (index === 2) {
      // Third cube - bottom left
      x = -spacing / 2;
      y = -spacing / 2;
      z = 0;
    } else {
      // Fourth cube - bottom right
      x = spacing / 2;
      y = -spacing / 2;
      z = 0;
    }
  } else if (totalCategories === 5) {
    // Special case for 5 cubes - 3-2 row layout
    const spacing = cubeSize * 1; // Distance between centers
    if (index === 0) {
      // First cube - top left
      x = -spacing / 2;
      y = spacing / 2;
      z = 0;
    } else if (index === 1) {
      // Second cube - top right
      x = spacing / 2;
      y = spacing / 2;
      z = 0;
    } else if (index === 2) {
      // Third cube - bottom left
      x = -spacing / 2;
      y = -spacing / 2;
      z = 0;
    } else if (index === 3) {
      // Fourth cube - bottom center
      x = spacing / 2;
      y = -spacing / 2;
      z = 0;
    } else {
      // Fifth cube - bottom right
      x = spacing * 1.5;
      y = -spacing / 2;
      z = 0;
    }
  } else if (totalCategories === 6) {
    // Special case for 6 cubes - 3-3 row layout
    const spacing = cubeSize * 1; // Distance between centers
    if (index === 0) {
      // First cube - top left
      x = -spacing;
      y = spacing / 2;
      z = 0;
    } else if (index === 1) {
      // Second cube - top center
      x = 0;
      y = spacing / 2;
      z = 0;
    } else if (index === 2) {
      // Third cube - top right
      x = spacing;
      y = spacing / 2;
      z = 0;
    } else if (index === 3) {
      // Fourth cube - bottom left
      x = -spacing;
      y = -spacing / 2;
      z = 0;
    } else if (index === 4) {
      // Fifth cube - bottom center
      x = 0;
      y = -spacing / 2;
      z = 0;
    } else {
      // Sixth cube - bottom right
      x = spacing;
      y = -spacing / 2;
      z = 0;
    }
  } else if (totalCategories === 7) {
    // Special case for 7 cubes - 4-3 row layout
    const spacing = cubeSize * 1; // Distance between centers
    if (index === 0) {
      // First cube - top left
      x = -spacing * 1.5;
      y = spacing / 2;
      z = 0;
    } else if (index === 1) {
      // Second cube - top left-center
      x = -spacing / 2;
      y = spacing / 2;
      z = 0;
    } else if (index === 2) {
      // Third cube - top right-center
      x = spacing / 2;
      y = spacing / 2;
      z = 0;
    } else if (index === 3) {
      // Fourth cube - top right
      x = spacing * 1.5;
      y = spacing / 2;
      z = 0;
    } else if (index === 4) {
      // Fifth cube - bottom left
      x = -spacing;
      y = -spacing / 2;
      z = 0;
    } else if (index === 5) {
      // Sixth cube - bottom center
      x = 0;
      y = -spacing / 2;
      z = 0;
    } else {
      // Seventh cube - bottom right
      x = spacing;
      y = -spacing / 2;
      z = 0;
    }
  } else if (totalCategories === 8) {
    // Special case for 8 cubes - 4-4 row layout
    const spacing = cubeSize * 1; // Distance between centers
    if (index === 0) {
      // First cube - top left
      x = -spacing * 1.5;
      y = spacing / 2;
      z = 0;
    } else if (index === 1) {
      // Second cube - top left-center
      x = -spacing / 2;
      y = spacing / 2;
      z = 0;
    } else if (index === 2) {
      // Third cube - top right-center
      x = spacing / 2;
      y = spacing / 2;
      z = 0;
    } else if (index === 3) {
      // Fourth cube - top right
      x = spacing * 1.5;
      y = spacing / 2;
      z = 0;
    } else if (index === 4) {
      // Fifth cube - bottom left
      x = -spacing * 1.5;
      y = -spacing / 2;
      z = 0;
    } else if (index === 5) {
      // Sixth cube - bottom left-center
      x = -spacing / 2;
      y = -spacing / 2;
      z = 0;
    } else if (index === 6) {
      // Seventh cube - bottom right-center
      x = spacing / 2;
      y = -spacing / 2;
      z = 0;
    } else {
      // Eighth cube - bottom right
      x = spacing * 1.5;
      y = -spacing / 2;
      z = 0;
    }
  } else {
    // Calculate spread radius so cubes touch but don't overlap
    // For cubes to touch without overlapping, the distance between centers should equal the cube size
    const spreadRadius = (cubeSize * 0.6) - 0.03; // Distance between centers for touching cubes (3px closer)
    
    // Distribute cubes evenly in all directions from center with minimal spread
    const goldenAngle = Math.PI * (3 - Math.sqrt(5)); // Golden angle for even distribution
    const theta = index * goldenAngle; // Azimuthal angle
    const phi = Math.acos(1 - 2 * index / Math.max(totalCategories - 1, 1)); // Polar angle
    
    // Convert spherical coordinates to Cartesian with very small radius
    x = spreadRadius * Math.sin(phi) * Math.cos(theta);
    y = spreadRadius * Math.cos(phi);
    z = spreadRadius * Math.sin(phi) * Math.sin(theta);
  }
  
  // Animation on mount
  useEffect(() => {
    const timer = setTimeout(() => setMounted(true), index * 100);
    return () => clearTimeout(timer);
  }, [index]);

  useFrame((state, delta) => {
    if (mesh.current) {
      // No rotation - keep cubes stationary

      // Scale animation on mount and click only
      if (mounted) {
        let targetScale = 1;
        if (clicked) {
          targetScale = 1.3; // Brief scale up on click
        }
        mesh.current.scale.lerp({ x: targetScale, y: targetScale, z: targetScale }, delta * 6);
      } else {
        mesh.current.scale.set(0, 0, 0);
      }

      // Color animation based on highlight
      if (mesh.current.material) {
        if (isHighlighted) {
          // Highlighted: orange color
          mesh.current.material.color.lerp({ r: 1, g: 0.42, b: 0.21 }, delta * 8);
        } else {
          // Default: deep vibrant purple (less white/bright)
          mesh.current.material.color.lerp({ r: 0.5, g: 0.2, b: 0.9 }, delta * 6);
        }
      }
      
      // Position animation based on highlight state
      let targetX = x;
      let targetY = y;
      let targetZ = z;
      
      if (isHighlighted) {
        // Highlighted cube moves outward from center and forward on z-axis
        const scale = 1.2; // Move 20% further from center
        targetX = x * scale;
        targetY = y * scale;
        targetZ = z * scale + 0.2; // Also move forward on z-axis
      }
      
      // Smooth position animation
      mesh.current.position.lerp({ x: targetX, y: targetY, z: targetZ }, delta * 9);
      
      // Spin animation on click
      if (!spun) {
        let next = progress + delta / 0.8; // 0.8 second spin
        if (next >= 1) {
          next = 1;
          setSpun(true);
        }
        setProgress(next);
        // Ease out cubic
        const eased = 1 - Math.pow(1 - next, 3);
        const spinY = 2 * Math.PI * eased;
        mesh.current.rotation.y = spinY;
      }
    }
  });

  const handleClick = () => {
    setProgress(0);
    setSpun(false);
    setClicked(true);
    // Reset clicked state after animation
    setTimeout(() => setClicked(false), 200);
    onClick && onClick();
  };

  return (
    <mesh
      ref={mesh}
      position={[x, y, z]}
      onClick={handleClick}
      style={{ cursor: 'pointer' }}
    >
      <boxGeometry args={[cubeSize, cubeSize, cubeSize]} />
      <meshStandardMaterial 
        color={isHighlighted ? '#ff6b35' : '#8020e6'}
        transparent
        opacity={mounted ? 1 : 0}
        emissive={isHighlighted ? '#ff6b35' : '#000000'}
        emissiveIntensity={isHighlighted ? 0.3 : 0}
        metalness={0.1}
        roughness={0.3}
      />
    </mesh>
  );
}

function CameraController({ cubeCount }) {
  const { camera } = useThree();
  
  useEffect(() => {
    if (camera) {
      // Set FOV based on number of cubes
      let fov;
      if (cubeCount <= 2) fov = 25;
      else if (cubeCount <= 4) fov = 30;
      else if (cubeCount <= 6) fov = 35;
      else if (cubeCount <= 8) fov = 40;
      else fov = 45;
      
      camera.fov = fov;
      camera.updateProjectionMatrix();
      
      // Position camera slightly above looking down
      camera.position.set(0, 2.5, 5);
    }
  }, [camera, cubeCount]);
  
  useFrame(() => {
    if (camera) {
      camera.lookAt(0, 0, 0);
    }
  });
  
  return null;
}

export default function CategoryCubes({ categories, highlightedCategoryId, onCubeClick }) {
  const groupRef = useRef();
  
  return (
    <div style={{ width: 300 , height: 180, margin: '0 auto' }}>
      <Canvas shadows>
        <CameraController cubeCount={categories.length} />
        <ambientLight intensity={0.6} />
        <directionalLight position={[2, 4, 5]} intensity={1.2} />
        <pointLight position={[-2, -2, 2]} intensity={0.5} />
        
        <group 
            ref={groupRef} 
          rotation={[-0.2, Math.PI / 10, 0]}
            position={[0, categories.length === 3 || categories.length === 1 ? -0.5 : 0, 0]}
        >
          {categories.map((category, index) => (
            <CategoryCube
              key={category.id}
              category={category}
              index={index}
              totalCategories={categories.length}
              isHighlighted={highlightedCategoryId === category.id}
              onClick={onCubeClick}
            />
          ))}
        </group>
      </Canvas>
    </div>
  );
}
